import {combineReducers} from 'redux';
import { usersReducer } from './UsersData/Reducers/UsersReducers'

const reducers= combineReducers({
    users: usersReducer
})

export default reducers;
